import React from 'react';

const CSSKeys = {
 "align-content" : "alignContent",
 "align-items" : "alignItems",
 "align-self" : "alignSelf",
 "all" : "all",
 "animation" : "animation",
 "animation-delay" : "animationDelay",
 "animation-direction" : "animationDirection",
 "animation-duration" : "animationDuration",
 "animation-fill-mode" : "animationFillMode",
 "animation-iteration-count" : "animationIterationCount",
 "animation-name" : "animationName",
 "animation-play-state" : "animationPlayState",
 "animation-timing-function" : "animationTimingFunction",
 "backdrop-filter" : "backdropFilter",
 "backface-visibility" : "backfaceVisibility",
 "background" : "background",
 "background-attachment" : "backgroundAttachment",
 "background-blend-mode" : "backgroundBlendMode",
 "background-clip" : "backgroundClip",
 "background-color" : "backgroundColor",
 "BackgroundColor" : "backgroundColor",
 "background-image" : "backgroundImage",
 "background-origin" : "backgroundOrigin",
 "background-position" : "backgroundPosition",
 "background-repeat" : "backgroundRepeat",
 "background-size" : "backgroundSize",
 "border" : "border",
 "border-bottom" : "borderBottom",
 "border-bottom-color" : "borderBottomColor",
 "border-bottom-left-radius" : "borderBottomLeftRadius",
 "border-bottom-right-radius" : "borderBottomRightRadius",
 "border-bottom-style" : "borderBottomStyle",
 "border-bottom-width" : "borderBottomWidth",
 "border-collapse" : "borderCollapse",
 "border-color" : "borderColor",
 "border-image" : "borderImage",
 "border-image-outset" : "borderImageOutset",
 "border-image-repeat" : "borderImageRepeat",
 "border-image-slice" : "borderImageSlice",
 "border-image-source" : "borderImageSource",
 "border-image-width" : "borderImageWidth",
 "border-left" : "borderLeft",
 "border-left-color" : "borderLeftColor",
 "border-left-style" : "borderLeftStyle",
 "border-left-width" : "borderLeftWidth",
 "border-radius" : "borderRadius",
 "border-right" : "borderRight",
 "border-right-color" : "borderRightColor",
 "border-right-style" : "borderRightStyle",
 "border-right-width" : "borderRightWidth",
 "border-spacing" : "borderSpacing",
 "border-style" : "borderStyle",
 "border-top" : "borderTop",
 "border-top-color" : "borderTopcolor",
 "borderTopLeftRadius" : "borderTopLeftRadius",
 "border-top-right-radius" : "borderTopRightRadius",
 "border-top-style" : "borderTopStyle",
 "border-top-width" : "borderTopWidth",
 "border-width" : "borderWidth",
 "bottom" : "bottom",
 "box-decoration-break" : "boxDecorationBreak",
 "box-shadow" : "boxShadow",
 "box-sizing" : "boxSizing",
 "break-after" : "breakAfter",
 "break-before" : "breakBefore",
 "break-inside" : "breakInside",
 
 "caption-side" : "caption-side",
 "caret-color" : "caret-color",
 "@charset" : "@charset",
 "clear" : "clear",
 "clip" : "clip",
 "color" : "color",
 "column-count" : "columnCount",
 "column-fill" : "columnFill",
 "column-gap" : "columnGap",
 "column-rule" : "columnRule",
 "column-rule-color" : "columnRuleColor",
 "column-rule-style" : "columnRuleStyle",
 "column-rule-width" : "columnRuleWidth",
 "column-span" : "columnSpan",
 "column-width" : "columnWidth",
 "columns" : "columns",
 "content" : "content",
 "counter-increment" : "counterIncrement",
 "counter-reset" : "counterReset",
 "cursor" : "cursor",
 
 "direction" : "direction",
 "display" : "display",
 
 "empty-cells" : "emptyCells",
 
 "filter" : "filter",
 "flex" : "flex",
 "flex-basis" : "flexBasis",
 "flex-direction" : "flexDirection",
 "flex-flow" : "flexFlow",
 "flex-grow" : "flexGrow",
 "flex-shrink" : "flexShrink",
 "flex-wrap" : "flexWrap",
 "float" : "float",
 "font" : "font",
 "@font-face" : "@fontFace",
 "font-family" : "fontFamily",
 "font-feature-settings" : "fontFeatureSettings",
 "@font-feature-values" : "@fontFeatureValues",
 "font-kerning" : "fontKerning",
 "font-language-override" : "fontLanguageOverride",
 "font-size" : "fontSize",
 "font-size-adjust" : "fontSizeAdjust",
 "font-stretch" : "fontStretch",
 "font-style" : "fontStyle",
 "font-synthesis" : "fontSynthesis",
 "font-variant" : "fontVariant",
 "font-variant-alternates" : "fontVariantAlternates",
 "font-variant-caps" : "fontVariantCaps",
 "font-variant-east-asian" : "fontVariantEastAsian",
 "font-variant-ligatures" : "fontVariantLigatures",
 "font-variant-numeric" : "fontVariantNumeric",
 "font-variant-position" : "fontVariantPosition",
 "font-weight" : "fontWeight",

 "LabelFontWeight" : "fontWeight",
 "LabelFontStyle" : "fontStyle",
 "LabelFontSize" : "fontSize",
 "LabelFontFamily" : "fontFamily",
 "LabelBackgoundColor" : "backgroundColor",
 "LabelFontColor" : "color",
 "Color" : "color",

  "BackColor" : "backgroundColor",

 "FontSize" : "fontSize",
 "ActiveTabFontSize" : "fontSize",
 "InActiveTabFontSize" : "fontSize",
 
 "FontStyle" : "font-style",
 "FontWeight" : "font-weight",
 "ActiveTabFontWeight" : "fontWeight",
 "InActiveTabFontWeight" : "fontWeight",
 
 "FontFamily" : "fontFamily",
 "FontColor" : "color",
 "font-color" : "color",
 "ActiveTabFontFamily" : "fontFamily",
 "InActiveTabFontFamily" : "fontFamily",

 "ActiveTabFontColor" : "color",
 "InActiveTabFontColor" : "color",
 "ActiveTabBackColor" : "backgroundColor",
 "InActiveTabBackColor" : "backgroundColor",

 "CornerRadius" : "border-radius",

 "ActiveTabBorderTopStyle" : "border-top-style",
 "InActiveTabBorderTopStyle" : "border-top-style",

 "ActiveTabBorderLeftStyle" : "border-left-style",
 "InActiveTabBorderLeftStyle" : "border-left-style",

 "ActiveTabBorderBottomStyle" : "border-bottom",
 "ActiveTabWidth" : "min-width",
 "InActiveTabWidth" : "min-width",
 "ActiveTabBorderRadius" :"border-radius",

 "ActiveTabBorderRightStyle" : "border-right-style",
 "InActiveTabBorderRightStyle" : "border-right-style",

 "ActiveBorderLeftStyle" : "border-left-style",

 "ActiveTabCornerRadius" : "border-radius",
 "TabBackgroundColor" :  "backgroundColor",
 "BorderRadius" : "border-radius",
 "ShowBorder" : "border-style",

 "ButtonAlignment" : "text-align",
 "SpacingLeft" : "padding-left",
 "SpacingRight" : "padding-right",
 "SpacingTop" : "padding-top",
 "SpacingBottom" : "padding-bottom",
 


 "gap" : "gap",
 "grid" : "grip",
 "gridArea" : "gridArea",
 "grid-auto-columns" : "gridAutoColumns",
 "grid-auto-flow" : "gridAutoFlow",
 "grid-auto-rows" : "gridAutoRows",
 "grid-column" : "gridColumn",
 "grid-column-end" : "gridColumnEnd",
 "grid-column-gap" : "gridColumnGap",
 "grid-column-start" : "gridColumnStart",
 "grid-gap" : "gridGap",
 "grid-row" : "gridRow",
 "grid-row-end" : "gridRowEnd",
 "grid-row-gap" : "gridRowGap",
 "grid-row-start" : "gridRowStart",
 "grid-template" : "gridTemplate",
 "grid-template-areas" : "gridTemplateAreas",
 "grid-template-columns" : "gridTemplateColumns",
 "grid-template-rows" : "grid-template-rows",
 
 "hanging-punctuation" : "hangingPunctuation",
 "height" : "height",
 "hyphens" : "hyphens",
 
 "image-rendering" : "imageRendering",
 "@import" : "@import",
 "isolation" : "isolation",
 
 "justify-content" : "justifyContent",
 "@keyframes" : "@keyframes",
 
 "left" : "left",
 "letter-spacing" : "letterSspacing",
 "line-break" : "lineBreak",
 "line-height" : "lineHeight",
 "list-style" : "listStyle",
 "list-style-image" : "liststyleImage",
 "list-style-position" : "liststylePosition",
 "list-style-type" : "liststyleType",
 
 "margin" : "margin",
 "margin-bottom" : "marginBottom",
 "margin-left" : "marginLeft",
 "margin-right" : "marginRight",
 "margin-top" : "marginTop",
 "mask" : "mask",
 "mask-type" : "maskType",
 "max-height" : "maxHeight",
 "max-width" : "maxWidth",
 "@media" : "@media",
 "min-height" : "minHeight",
 "min-width" : "minWidth",
 "mix-blend-mode" : "mixBlendMode",
 
 "object-fit" : "objectFit",
 "object-position" : "objectPosition",
 "opacity" : "opacity",
 "order" : "order",
 "orphans" : "orphans",
 "outline" : "outline",
 "outline-color" : "outlineColor",
 "outline-offset" : "outlineOffset",
 "outline-style" : "outlineStyle",
 "outline-width" : "outlineWidth",
 "overflow" : "overflow",
 "overflow-wrap" : "overflowWrap",
 "overflow-x" : "overflowX",
 "overflow-y" : "overflowY",
 
 "padding" : "padding",
 "padding-bottom" : "paddingBottom",
 "padding-left" : "paddingLeft",
 "padding-right" : "paddingRight",
 "padding-top" : "paddingTop",
 "page-break-after" : "pageBreakafter",
 "page-break-before" : "pageBreakBefore",
 "page-break-inside" : "pageBreakInside",
 "perspective" : "perspective",
 "perspective-origin" : "perspectiveOrigin",
 "pointer-events" : "pointerEvents",
 "position" : "position",
 
 "quotes" : "quotes",
 
 "resize" : "resize",
 "right" : "right",
 "row-gap" : "rowGap",
 
 "scroll-behavior" : "scrollBehavior",
 
 "tab-size" : "tabSize",
 "table-layout" : "tableLayout",
 "text-align" : "textAlign",
 "text-align-last" : "textAlignLast",
 "text-combine-upright" : "textCombineUpright",
 "text-decoration" : "textDecoration",
 "text-decoration-color" : "textDecorationColor",
 "text-decoration-line" : "textDecorationLine",
 "text-decoration-style" : "textDecorationStyle",
 "text-indent" : "textIndent",
 "text-justify" : "textJustify",
 "text-orientation" : "textOrientation",
 "text-overflow" : "textOverflow",
 "text-shadow" : "textShadow",
 "text-transform" : "textTransform",
 "text-underline-position" : "textUnderlinePosition",
 "top" : "top",
 "transform" : "transform",
 "transform-origin" : "transformOrigin",
 "transform-style" : "transformStyle",
 "transition" : "transition",
 "transition-delay" : "transitionDelay",
 "transition-duration" : "transitionDuration",
 "transition-property" : "transitionProperty",
 "transition-timing-function" : "transitionTimingFunction",
 
 "unicode-bidi" : "unicodeBidi",
 "user-select" : "userSelect",
 
 "vertical-align" : "verticalAlign",
 "visibility" : "visibility",
 
 "white-space" : "whiteSpace",
 "widows" : "widows",
 "word-break" : "wordBreak",
 "word-spacing" : "wordSpacing",
 "word-wrap" : "wordWrap",
 "writing-mode" : "writingMode",
 
 "z-index" : "zIndex",
 "TableHeaderBackgroundColor": "backgroundColor",
 "TableHeaderFontColor": "color",
 "TableHeaderLineColor": "color-",
 "TableHeaderFontSize" : "fontSize",
 "TableHeaderTextAlignment" : "text-align",
 "TableHeaderFontWeight": "fontWeight",
 "TableHeaderFontStyle": "fontStyle",
 "TableHeaderFontFamily": "fontFamily",
 "ColumnHeaderFontWeight" : "fontWeight",
 "ColumnValuesFontWeight": "fontWeight",
 "ColumnHeaderAlignment": "text-align",
 "ColumnValuesAlignment": "text-align",
 "ColumnHeaderColor" : "color",
 "ColumnValuesColor": "color",
 "ColumnWidth" : "width",
 "VisibleOnTable" : "display",
 "ListviewTitleFontColor": "color",
 "ListviewTitleFontWeight": "fontWeight",
 "ListviewTitleFontStyle": "fontStyle",
 "ListviewTitleFontFamily": "fontFamily",
 "ListviewTitleFontSize" : "fontSize",
 "TableTitleFontColor": "color",
 "TableHeaderHeight" : "height",
 "ListviewColumnHeight" : "height",
"ListviewColumnFontFamily" : "fontFamily",
"ListviewColumnFontWeight" : "fontWeight",
"ListviewColumnFontSize" : "fontSize",
"ListviewColumnTextAlignment" : "text-align",
"ListviewColumnBackgroundColor" : "background-color",
"ListviewColumnFontColor" : "color",
"ActiveStateBackgroundColor" : "background-color",
"TotalFontColor": "color",
"CellFontColor" : "color",
"CellBackColor" : "background-color",
"TotalFontSize" : "font-size",
"TotalBackColor":"background-color",
"widthInPx": "width",
"width" : "width",
"HeaderBackColor": "background-color",
"LabelAlignment":"text-align",
"CellFontSize": "font-size",
"HeaderFontColor": "color",
"HeaderFontSize":"font-size",
"BorderColor":"border-color",
"BorderWidth" : "border-width",
"Visible":"display",
"CombinedFontWeight": "font-weight",
"Height":"max-height",
"LabelSwitchAlignment":"flex-wrap",
"OverlayBackground":"background-color",
"OverlayButtonAlignmentright" : "right",
"OverlayButtonAlignmentleft" : "left",
 

 
}

export default CSSKeys ;